// pp-calc-rotulos.js — Generador de Rótulos de Almacén y Envío para Imprimir
// (/pages/rotulos-para-imprimir)
//
// NO es una calculadora: es un generador con vista previa e impresión. El
// almacén elige un rótulo (FRÁGIL, letrero de zona, ubicación de rack…),
// lo ve tal cual va a salir, y window.print() lo manda a hoja carta — el
// @media print de assets/pp-calc-rotulos.css oculta el resto de la página.
//
// Lógica pura (presets + estructura de datos de la hoja) en PPRotulos,
// probada en tests/calc-rotulos.test.mjs. El wiring de DOM va aparte,
// protegido con typeof document.
//
// SEGURIDAD: el texto del usuario (texto libre y código de rack) viaja como
// DATO por esta capa y se pinta ÚNICAMENTE con textContent en el wiring —
// jamás innerHTML con texto del usuario.
(function (root) {
  'use strict';

  // Los textos van en MAYÚSCULAS literales: son señalética física impresa,
  // exenta de la regla de botones (que se pintan en mayúscula vía CSS).
  var PRESETS = [
    { id: 'fragil', texto: 'FRÁGIL', icono: 'copa', grupo: 'envio' },
    { id: 'este-lado-arriba', texto: 'ESTE LADO ARRIBA', icono: 'flechas', grupo: 'envio' },
    { id: 'no-estibar', texto: 'NO ESTIBAR', icono: 'no-estibar', grupo: 'envio' },
    { id: 'manejese-con-cuidado', texto: 'MANÉJESE CON CUIDADO', icono: 'manos', grupo: 'envio' },
    { id: 'pesado', texto: 'PESADO', icono: 'pesa', grupo: 'envio' },
    { id: 'zona-recibo', texto: 'RECIBO', icono: 'recibo', grupo: 'almacen' },
    { id: 'zona-empaque', texto: 'EMPAQUE', icono: 'caja', grupo: 'almacen' },
    { id: 'zona-envios', texto: 'ENVÍOS', icono: 'camion', grupo: 'almacen' },
    { id: 'zona-devoluciones', texto: 'DEVOLUCIONES', icono: 'devolucion', grupo: 'almacen' },
    { id: 'zona-calidad', texto: 'CALIDAD', icono: 'calidad', grupo: 'almacen' },
    { id: 'rack', texto: '', icono: null, grupo: 'almacen', input: 'rack' },
    { id: 'libre', texto: '', icono: null, grupo: 'almacen', input: 'libre' }
  ];

  function presetPorId(id) {
    for (var i = 0; i < PRESETS.length; i++) {
      if (PRESETS[i].id === id) return PRESETS[i];
    }
    return null;
  }

  // El texto del usuario NO se transforma ni se interpreta: se recorta y ya.
  // La MAYÚSCULA visual del rótulo la pone el CSS (text-transform), para que
  // el dato viaje intacto.
  function limpiar(t) {
    if (t === null || t === undefined) return '';
    return String(t).trim();
  }

  // Escala tipográfica del rótulo según el texto: la palabra más larga manda
  // (una palabra no se puede partir bonito), el largo total desempata.
  function escalaDe(texto) {
    var palabras = String(texto).split(/\s+/).filter(Boolean);
    var larga = 0;
    for (var i = 0; i < palabras.length; i++) {
      if (palabras[i].length > larga) larga = palabras[i].length;
    }
    if (texto.length <= 8 && larga <= 8) return 'grande';
    if (texto.length <= 18 && larga <= 9) return 'media';
    return 'chica';
  }

  // Entradas: { preset, textoRack, textoLibre } → datos de UN rótulo:
  // { texto, icono, escala }. El texto es dato puro (sin markup): la capa de
  // DOM lo debe asignar con textContent.
  function datosRotulo(e) {
    if (!e) return null;
    var p = presetPorId(e.preset);
    if (!p) return null;
    var texto = p.texto;
    if (p.input === 'rack') texto = limpiar(e.textoRack) || 'A-03';
    if (p.input === 'libre') texto = limpiar(e.textoLibre) || 'TU TEXTO';
    return { texto: texto, icono: p.icono, escala: escalaDe(texto) };
  }

  // Formatos de salida. Los de etiqueta son tamaños REALES de rollo térmico:
  // los que vendemos (pedido de Padrino, 1-sep-2026) — 4×6" (Dymo 4XL
  // 1744907 y Zebra), 4×8" (Zebra) y Dymo LW de envío 2 1/8×4" (30323) — más
  // los genéricos de la industria: 4×4" (100×100 mm, el común de
  // marketplaces), 4×2", 3×2" y 2×1". En etiqueta la página ES la etiqueta:
  // margen 0 y la orientación de hoja no aplica (la decide el driver de la
  // impresora térmica). Los de papel: carta (1, 2, 4 o 6 por hoja) y doble
  // carta/tabloide 11×17" (`hoja` es el keyword CSS de @page; ledger = 11×17).
  var FORMATOS = {
    carta1: { porHoja: 1, etiqueta: false },
    mediacarta: { porHoja: 2, etiqueta: false },
    carta4: { porHoja: 4, etiqueta: false },
    carta6: { porHoja: 6, etiqueta: false },
    tabloide: { porHoja: 1, etiqueta: false, hoja: 'ledger' },
    e4x6: { porHoja: 1, etiqueta: true, pagina: '4in 6in' },
    e4x8: { porHoja: 1, etiqueta: true, pagina: '4in 8in' },
    e4x4: { porHoja: 1, etiqueta: true, pagina: '4in 4in' },
    e4x2: { porHoja: 1, etiqueta: true, pagina: '4in 2in' },
    e3x2: { porHoja: 1, etiqueta: true, pagina: '3in 2in' },
    e2x1: { porHoja: 1, etiqueta: true, pagina: '2in 1in' },
    dymo2x4: { porHoja: 1, etiqueta: true, pagina: '2.125in 4in' }
  };

  // Rejilla de los formatos multi-rótulo (celdas = porHoja SIEMPRE). En
  // horizontal la rejilla se voltea para que cada rótulo conserve una
  // proporción sana (media carta apaisada = 2 columnas, no 2 tiras).
  function rejillaDe(porHoja, orientacion) {
    var apaisada = orientacion === 'horizontal';
    if (porHoja === 6) return apaisada ? { columnas: 3, filas: 2 } : { columnas: 2, filas: 3 };
    if (porHoja === 4) return { columnas: 2, filas: 2 };
    if (porHoja === 2) return apaisada ? { columnas: 2, filas: 1 } : { columnas: 1, filas: 2 };
    return { columnas: 1, filas: 1 };
  }

  // El string del @page que el wiring inyecta. Puro para poderlo probar.
  // Margin 0 SIEMPRE: sin margen, Chrome no tiene dónde pintar su fecha y
  // su URL (encabezado/pie del navegador) — el margen visual de la carta lo
  // pone el padding de la hoja en el CSS de impresión.
  function paginaCss(formato, orientacion) {
    var f = FORMATOS[formato] || FORMATOS.carta1;
    if (f.etiqueta) return '@page { size: ' + f.pagina + '; margin: 0; }';
    var hoja = f.hoja || 'letter';
    return orientacion === 'horizontal'
      ? '@page { size: ' + hoja + ' landscape; margin: 0; }'
      : '@page { size: ' + hoja + ' portrait; margin: 0; }';
  }

  // Entradas: { preset, textoRack, textoLibre, formato, orientacion } →
  // la hoja completa: { formato, porHoja, etiqueta, orientacion, items }.
  // Defaults sensatos: 1 rótulo a hoja carta completa, vertical.
  // Compat: porHoja=4 legado equivale a formato carta4.
  function armarHoja(e) {
    var r = datosRotulo(e);
    if (!r) return null;
    var formato = FORMATOS[e.formato] ? e.formato : (e.porHoja === 4 || e.porHoja === '4' ? 'carta4' : 'carta1');
    var f = FORMATOS[formato];
    var orientacion = e.orientacion === 'horizontal' && !f.etiqueta ? 'horizontal' : 'vertical';
    var items = [];
    for (var i = 0; i < f.porHoja; i++) items.push(r);
    return { formato: formato, porHoja: f.porHoja, etiqueta: f.etiqueta, orientacion: orientacion, items: items };
  }

  // ── PDF hecho en casa ─────────────────────────────────────────────────
  // El diálogo de imprimir del navegador resultó una lotería (los @page de
  // CSS ajenos, la política de encabezados de cada Chrome…). La salida
  // definitiva (pedido de Padrino, 1-sep): NOSOTROS generamos el PDF con la
  // página del tamaño EXACTO del formato y el usuario lo descarga — de un
  // PDF, cualquier impresora imprime bien. Sin librerías: es un PDF mínimo
  // de una página con una imagen JPEG (el rótulo rasterizado del canvas).

  // Tamaño de página en puntos (1 in = 72 pt) por formato. Los multi-rótulo
  // de carta comparten la página carta (612×792): el recorte es del usuario.
  var PUNTOS = {
    carta1: { w: 612, h: 792 },
    mediacarta: { w: 612, h: 792 },
    carta4: { w: 612, h: 792 },
    carta6: { w: 612, h: 792 },
    tabloide: { w: 792, h: 1224 },
    e4x6: { w: 288, h: 432 },
    e4x8: { w: 288, h: 576 },
    e4x4: { w: 288, h: 288 },
    e4x2: { w: 288, h: 144 },
    e3x2: { w: 216, h: 144 },
    e2x1: { w: 144, h: 72 },
    dymo2x4: { w: 153, h: 288 }
  };

  // Construye los bytes de un PDF 1.4 de UNA página con el JPEG a página
  // completa. jpegBytes: Uint8Array; wPt/hPt: página en puntos; wPx/hPx:
  // pixeles del JPEG. Puro: probado en node con bytes sintéticos.
  function pdfConImagen(jpegBytes, wPt, hPt, wPx, hPx) {
    var enc = new TextEncoder();
    var contenido = 'q ' + wPt + ' 0 0 ' + hPt + ' 0 0 cm /Im1 Do Q';
    var objs = [
      '<< /Type /Catalog /Pages 2 0 R >>',
      '<< /Type /Pages /Kids [3 0 R] /Count 1 >>',
      '<< /Type /Page /Parent 2 0 R /MediaBox [0 0 ' + wPt + ' ' + hPt + '] /Resources << /XObject << /Im1 4 0 R >> >> /Contents 5 0 R >>',
      null, // el 4 es la imagen, va aparte por el stream binario
      '<< /Length ' + contenido.length + ' >>\nstream\n' + contenido + '\nendstream'
    ];
    var partes = [];
    var offset = 0;
    var offsets = [];
    function put(bytes) { partes.push(bytes); offset += bytes.length; }
    put(enc.encode('%PDF-1.4\n'));
    for (var i = 0; i < objs.length; i++) {
      offsets[i] = offset;
      if (i === 3) {
        put(enc.encode('4 0 obj\n<< /Type /XObject /Subtype /Image /Width ' + wPx + ' /Height ' + hPx +
          ' /ColorSpace /DeviceRGB /BitsPerComponent 8 /Filter /DCTDecode /Length ' + jpegBytes.length + ' >>\nstream\n'));
        put(jpegBytes);
        put(enc.encode('\nendstream\nendobj\n'));
      } else {
        put(enc.encode((i + 1) + ' 0 obj\n' + objs[i] + '\nendobj\n'));
      }
    }
    var xrefPos = offset;
    var xref = 'xref\n0 6\n0000000000 65535 f \n';
    for (var j = 0; j < 5; j++) {
      xref += String(offsets[j]).padStart(10, '0') + ' 00000 n \n';
    }
    put(enc.encode(xref + 'trailer\n<< /Size 6 /Root 1 0 R >>\nstartxref\n' + xrefPos + '\n%%EOF'));
    var total = new Uint8Array(offset);
    var pos = 0;
    for (var k = 0; k < partes.length; k++) { total.set(partes[k], pos); pos += partes[k].length; }
    return total;
  }

  // Nombre de archivo amable: "Rotulo FRAGIL 4x6.pdf"
  function nombreArchivo(texto, formato) {
    var etiquetas = {
      carta1: 'carta', mediacarta: 'media carta', carta4: 'carta 4', carta6: 'carta 6',
      tabloide: 'tabloide 11x17', e4x6: '4x6', e4x8: '4x8', e4x4: '4x4', e4x2: '4x2',
      e3x2: '3x2', e2x1: '2x1', dymo2x4: 'Dymo 2x4'
    };
    var limpio = String(texto).normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^A-Za-z0-9 -]/g, '').trim().slice(0, 30);
    return 'Rotulo ' + limpio + ' ' + (etiquetas[formato] || 'carta') + '.pdf';
  }

  root.PPRotulos = {
    PRESETS: PRESETS,
    FORMATOS: FORMATOS,
    PUNTOS: PUNTOS,
    rejillaDe: rejillaDe,
    presetPorId: presetPorId,
    datosRotulo: datosRotulo,
    armarHoja: armarHoja,
    paginaCss: paginaCss,
    pdfConImagen: pdfConImagen,
    nombreArchivo: nombreArchivo
  };
})(typeof window !== 'undefined' ? window : globalThis);

// ── Wiring de la página (no corre en tests de node) ────────────────────────
(function () {
  'use strict';
  if (typeof document === 'undefined') return;

  var SVG_NS = 'http://www.w3.org/2000/svg';
  var PIE = 'parapaquetes.com · Material de Empaque';

  function listo(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  listo(function () {
    var raiz = document.querySelector('[data-pp-calc-rotulos]');
    if (!raiz) return;
    var R = window.PPRotulos;
    var form = raiz.querySelector('form');
    var hojaEl = raiz.querySelector('[data-rotulo-hoja]');
    var campoRack = raiz.querySelector('[data-campo-rack]');
    var campoLibre = raiz.querySelector('[data-campo-libre]');
    var botonImprimir = raiz.querySelector('[data-imprimir]');
    if (!form || !hojaEl) return;

    // La orientación de la HOJA impresa se declara con @page; como @page no
    // puede depender de una clase, este <style> propio se reescribe al vuelo.
    var estiloPagina = document.createElement('style');
    document.head.appendChild(estiloPagina);
    function ajustarPagina(hoja) {
      estiloPagina.textContent = R.paginaCss(hoja.formato, hoja.orientacion);
    }

    // En formatos de etiqueta la orientación no aplica y aparece la venta
    // de los rollos; en carta al revés.
    var campoOrientacion = raiz.querySelector('[data-campo-orientacion]');
    var hintRollos = raiz.querySelector('[data-hint-rollos]');
    function ajustarControles(hoja) {
      if (campoOrientacion) campoOrientacion.hidden = hoja.etiqueta;
      if (hintRollos) hintRollos.hidden = !hoja.etiqueta;
    }

    // El CSS de la vista previa solo conoce los formatos originales (carta,
    // 4 por hoja y las 3 etiquetas de siempre). Para los demás, la
    // proporción real sale de PUNTOS y la rejilla de rejillaDe — estilos
    // calculados al vuelo, misma técnica que el <style> del @page.
    var CSS_YA_SABE = { carta1: true, carta4: true, e4x6: true, e4x8: true, dymo2x4: true };
    function ajustarPreview(hoja) {
      if (CSS_YA_SABE[hoja.formato]) {
        hojaEl.style.aspectRatio = '';
        hojaEl.style.maxWidth = '';
      } else {
        var pts = R.PUNTOS[hoja.formato] || R.PUNTOS.carta1;
        var w = pts.w;
        var h = pts.h;
        if (!hoja.etiqueta && hoja.orientacion === 'horizontal') { w = pts.h; h = pts.w; }
        hojaEl.style.aspectRatio = w + ' / ' + h;
        // ~75 px por pulgada, acotado al ancho de la columna de preview.
        hojaEl.style.maxWidth = Math.max(180, Math.min(440, Math.round(w * 75 / 72))) + 'px';
      }
      var g = R.rejillaDe(hoja.porHoja, hoja.orientacion);
      var esLaDe4 = hoja.porHoja === 4; // esa rejilla ya la trae el CSS
      hojaEl.style.gridTemplateColumns = !esLaDe4 && g.columnas > 1 ? 'repeat(' + g.columnas + ', 1fr)' : '';
      hojaEl.style.gridTemplateRows = !esLaDe4 && hoja.porHoja > 1 ? 'repeat(' + g.filas + ', 1fr)' : '';
    }

    function pintarHoja(hoja) {
      hojaEl.dataset.orientacion = hoja.orientacion;
      hojaEl.dataset.porHoja = String(hoja.porHoja);
      hojaEl.dataset.formato = hoja.formato;
      ajustarPreview(hoja);
      hojaEl.textContent = '';
      for (var i = 0; i < hoja.items.length; i++) {
        var item = hoja.items[i];
        var rot = document.createElement('div');
        rot.className = 'pp-rotulo';
        rot.dataset.escala = item.escala;

        var cuerpo = document.createElement('div');
        cuerpo.className = 'pp-rotulo__cuerpo';
        if (item.icono) {
          var svg = document.createElementNS(SVG_NS, 'svg');
          svg.setAttribute('class', 'pp-rotulo__icono');
          svg.setAttribute('viewBox', '0 0 24 24');
          svg.setAttribute('aria-hidden', 'true');
          var use = document.createElementNS(SVG_NS, 'use');
          use.setAttribute('href', '#pp-rotulo-ic-' + item.icono);
          svg.appendChild(use);
          cuerpo.appendChild(svg);
        }
        var texto = document.createElement('p');
        texto.className = 'pp-rotulo__texto';
        // SEGURIDAD: texto del usuario SOLO con textContent, jamás innerHTML.
        texto.textContent = item.texto;
        cuerpo.appendChild(texto);
        rot.appendChild(cuerpo);

        var pie = document.createElement('p');
        pie.className = 'pp-rotulo__pie';
        pie.textContent = PIE;
        rot.appendChild(pie);

        hojaEl.appendChild(rot);
      }
    }

    function ajustarCampos(presetId) {
      var p = R.presetPorId(presetId);
      if (campoRack) campoRack.hidden = !(p && p.input === 'rack');
      if (campoLibre) campoLibre.hidden = !(p && p.input === 'libre');
    }

    function render() {
      var f = new FormData(form);
      var entrada = {
        preset: f.get('preset'),
        textoRack: f.get('texto_rack'),
        textoLibre: f.get('texto_libre'),
        formato: f.get('formato'),
        orientacion: f.get('orientacion')
      };
      ajustarCampos(entrada.preset);
      var hoja = R.armarHoja(entrada);
      if (!hoja) return;
      ajustarPagina(hoja);
      ajustarControles(hoja);
      pintarHoja(hoja);
    }

    // La vista previa se actualiza al cambiar cualquier control.
    form.addEventListener('input', render);
    form.addEventListener('change', render);
    form.addEventListener('submit', function (ev) { ev.preventDefault(); });

    // ── Impresión real ────────────────────────────────────────────────────
    // La hoja se MUEVE a ser hija directa de <body> mientras se imprime:
    // así el documento impreso es SOLO el rótulo (una página, sin el resto
    // del layout ocupando altura invisible — la lección del QA del 1-sep).
    // beforeprint/afterprint cubren tanto nuestro botón como Cmd+P.
    var marcador = document.createComment('pp-rotulo-hoja-va-aqui');
    var tituloOriginal = document.title;
    function alImprimir() {
      if (!hojaEl.parentNode || hojaEl.parentNode === document.body) return;
      hojaEl.parentNode.insertBefore(marcador, hojaEl);
      document.body.appendChild(hojaEl);
      document.body.classList.add('pp-imprimiendo-rotulo');
      // El @page nuestro se muda al FINAL del documento justo antes de
      // imprimir: los CSS de apps (reseñas, chat) se inyectan después del
      // nuestro y un @page ajeno le ganaba por orden — con la fecha y la
      // URL de Chrome apareciendo en el papel (QA de Padrino, 1-sep).
      document.body.appendChild(estiloPagina);
      // El nombre del PDF sale del título del documento — que diga qué es.
      var f = new FormData(form);
      var hoja = R.armarHoja({
        preset: f.get('preset'), textoRack: f.get('texto_rack'),
        textoLibre: f.get('texto_libre'), formato: f.get('formato'), orientacion: f.get('orientacion')
      });
      if (hoja && hoja.items.length) {
        document.title = 'Rótulo ' + hoja.items[0].texto + ' — Para Paquetes';
      }
    }
    function alTerminar() {
      if (marcador.parentNode) {
        marcador.parentNode.insertBefore(hojaEl, marcador);
        marcador.parentNode.removeChild(marcador);
      }
      document.body.classList.remove('pp-imprimiendo-rotulo');
      document.title = tituloOriginal;
    }
    window.addEventListener('beforeprint', alImprimir);
    window.addEventListener('afterprint', alTerminar);

    if (botonImprimir) {
      botonImprimir.addEventListener('click', function () { window.print(); });
    }

    // ── Descargar PDF (el camino recomendado) ────────────────────────────
    // Rasteriza el rótulo a 300 dpi en un canvas y lo empaca en el PDF
    // mínimo de PPRotulos.pdfConImagen — página del tamaño EXACTO del
    // formato. Del PDF descargado, cualquier impresora sale bien.
    var DPI = 300;
    var NAVY = '#0E3A5C';
    var GRIS = '#6b7280';
    var PIE = 'parapaquetes.com · Material de Empaque';

    function iconoAImagen(icono) {
      return new Promise(function (resolver) {
        if (!icono) return resolver(null);
        var sym = document.getElementById('pp-rotulo-ic-' + icono);
        if (!sym) return resolver(null);
        var ser = new XMLSerializer();
        var dentro = '';
        for (var c = 0; c < sym.children.length; c++) dentro += ser.serializeToString(sym.children[c]);
        var svg = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="' + (sym.getAttribute('viewBox') || '0 0 24 24') +
          '" fill="none" stroke="' + NAVY + '" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">' +
          dentro + '</svg>';
        var img = new Image();
        img.onload = function () { resolver(img); };
        img.onerror = function () { resolver(null); };
        img.src = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svg);
      });
    }

    function dibujarCelda(ctx, x, y, w, h, item, img) {
      var min = Math.min(w, h);
      var borde = Math.max(4, Math.round(min * 0.03));
      var relleno = Math.round(borde * 1.6);
      ctx.strokeStyle = NAVY;
      ctx.lineWidth = borde;
      ctx.strokeRect(x + borde / 2, y + borde / 2, w - borde, h - borde);
      var interiorX = x + borde + relleno;
      var interiorW = w - 2 * (borde + relleno);
      var centroX = x + w / 2;

      // Icono arriba del texto, texto al centro, pie pegado abajo
      var tamIcono = img ? Math.round(h * 0.2) : 0;
      var base = { grande: 0.17, media: 0.12, chica: 0.085 };
      var tamTexto = Math.round(h * (base[item.escala] || 0.12));

      // Partir el texto en líneas que quepan (greedy por palabras)
      ctx.font = '800 ' + tamTexto + 'px "Inter Tight", -apple-system, sans-serif';
      var palabras = String(item.texto).split(/\s+/).filter(Boolean);
      var lineas = [];
      var actual = '';
      for (var i = 0; i < palabras.length; i++) {
        var candidata = actual ? actual + ' ' + palabras[i] : palabras[i];
        if (ctx.measureText(candidata).width <= interiorW || !actual) { actual = candidata; }
        else { lineas.push(actual); actual = palabras[i]; }
      }
      if (actual) lineas.push(actual);
      // Encoger hasta que la línea más ancha quepa
      var masAncha = function () {
        var mx = 0;
        for (var l = 0; l < lineas.length; l++) mx = Math.max(mx, ctx.measureText(lineas[l]).width);
        return mx;
      };
      while (tamTexto > 12 && masAncha() > interiorW) {
        tamTexto = Math.round(tamTexto * 0.94);
        ctx.font = '800 ' + tamTexto + 'px "Inter Tight", -apple-system, sans-serif';
      }

      var altoBloque = tamIcono + (tamIcono ? tamTexto * 0.35 : 0) + lineas.length * tamTexto * 1.12;
      var yCursor = y + (h - altoBloque) / 2;
      if (img) {
        ctx.drawImage(img, centroX - tamIcono / 2, yCursor, tamIcono, tamIcono);
        yCursor += tamIcono + tamTexto * 0.35;
      }
      ctx.fillStyle = NAVY;
      ctx.textAlign = 'center';
      ctx.textBaseline = 'top';
      for (var ln = 0; ln < lineas.length; ln++) {
        ctx.fillText(lineas[ln], centroX, yCursor, interiorX + interiorW);
        yCursor += tamTexto * 1.12;
      }
      // Pie de marca, discreto — y SIEMPRE en una línea: se encoge hasta
      // caber (en la Dymo chica el pie grande se comía la etiqueta).
      var tamPie = Math.max(8, Math.round(h * 0.016));
      ctx.font = '400 ' + tamPie + 'px "Inter Tight", -apple-system, sans-serif';
      while (tamPie > 6 && ctx.measureText(PIE).width > interiorW) {
        tamPie -= 1;
        ctx.font = '400 ' + tamPie + 'px "Inter Tight", -apple-system, sans-serif';
      }
      ctx.fillStyle = GRIS;
      ctx.textBaseline = 'bottom';
      ctx.fillText(PIE, centroX, y + h - borde - relleno * 0.6, interiorW);
    }

    function rasterizar(hoja, img) {
      var pts = R.PUNTOS[hoja.formato] || R.PUNTOS.carta1;
      var wPt = pts.w;
      var hPt = pts.h;
      if (!hoja.etiqueta && hoja.orientacion === 'horizontal') { wPt = pts.h; hPt = pts.w; }
      var esc = DPI / 72;
      var canvas = document.createElement('canvas');
      canvas.width = Math.round(wPt * esc);
      canvas.height = Math.round(hPt * esc);
      var ctx = canvas.getContext('2d');
      ctx.fillStyle = '#ffffff';
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      var margen = Math.round((hoja.etiqueta ? 2 : 10) / 25.4 * DPI); // mm → px
      var utilW = canvas.width - 2 * margen;
      var utilH = canvas.height - 2 * margen;
      if (hoja.porHoja > 1) {
        var g = R.rejillaDe(hoja.porHoja, hoja.orientacion);
        var gap = Math.round(6 / 25.4 * DPI);
        var cw = (utilW - gap * (g.columnas - 1)) / g.columnas;
        var chh = (utilH - gap * (g.filas - 1)) / g.filas;
        for (var i = 0; i < hoja.porHoja; i++) {
          var col = i % g.columnas;
          var fila = (i - col) / g.columnas;
          dibujarCelda(ctx, margen + col * (cw + gap), margen + fila * (chh + gap), cw, chh, hoja.items[i], img);
        }
      } else {
        dibujarCelda(ctx, margen, margen, utilW, utilH, hoja.items[0], img);
      }
      return { canvas: canvas, wPt: wPt, hPt: hPt };
    }

    function descargar() {
      var f = new FormData(form);
      var hoja = R.armarHoja({
        preset: f.get('preset'), textoRack: f.get('texto_rack'),
        textoLibre: f.get('texto_libre'), formato: f.get('formato'), orientacion: f.get('orientacion')
      });
      if (!hoja) return;
      var listoFuentes = (document.fonts && document.fonts.ready) ? document.fonts.ready : Promise.resolve();
      listoFuentes
        .then(function () { return iconoAImagen(hoja.items[0].icono); })
        .then(function (img) {
          var r = rasterizar(hoja, img);
          var dataUrl = r.canvas.toDataURL('image/jpeg', 0.92);
          var b64 = dataUrl.split(',')[1];
          var bin = atob(b64);
          var jpeg = new Uint8Array(bin.length);
          for (var i = 0; i < bin.length; i++) jpeg[i] = bin.charCodeAt(i);
          var pdf = R.pdfConImagen(jpeg, r.wPt, r.hPt, r.canvas.width, r.canvas.height);
          var blob = new Blob([pdf], { type: 'application/pdf' });
          var a = document.createElement('a');
          a.href = URL.createObjectURL(blob);
          a.download = R.nombreArchivo(hoja.items[0].texto, hoja.formato);
          document.body.appendChild(a);
          a.click();
          setTimeout(function () { URL.revokeObjectURL(a.href); a.remove(); }, 2000);
        })
        .catch(function () { window.print(); }); // si algo truena, el plan B es imprimir
    }

    var botonDescargar = raiz.querySelector('[data-descargar]');
    if (botonDescargar) {
      botonDescargar.addEventListener('click', descargar);
    }

    render();
  });
})();
